/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-benefit',
    imports: [MatIconModule],
    templateUrl: './benefit.component.html',
    styleUrl: './benefit.component.scss'
})
export class BenefitComponent {
    @Input() icon : string;
    @Input() head : string;
    @Input() text: string;
}
